import { StarHalfIcon, StarIcon, StarSolidIcon } from '@fiverr-private/visuals';

export const variantToStar = {
    empty: StarIcon,
    half: StarHalfIcon,
    full: StarSolidIcon,
};
